import { Dialog } from 'primereact/dialog';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { RedesignButton } from 'src/redesign/components/RedesignButton';
import { Text } from 'src/redesign/components/Text';
import { closeRoleSelection, openAttendeeTicketsModal } from '../store/reducer';
import { isRoleSelectionVisibleSelector } from '../store/selectors';
import { fetchAttendeeTickets } from 'src/redesign/features/Attendees/store/actions';
import { accountSelector } from 'src/redesign/features/Account/store/selectors';
import { getSelectedSiteDataSelector } from 'src/redesign/features/SelectedSite/store/selectors';
import { selectSettings } from 'src/features/settings-slice';
import Intercom from '@intercom/messenger-js-sdk';
import { isEmpty } from 'lodash';
import styles from './RoleSelectionModal.module.scss';

export const RoleSelectionModal = () => {
  const dispatch = useAppDispatch();
  const isVisible = useAppSelector(isRoleSelectionVisibleSelector);
  const account = useAppSelector(accountSelector);
  const site = useAppSelector(getSelectedSiteDataSelector);
  const settings = useAppSelector(selectSettings);

  const handleOrganizerClick = () => {
    dispatch(closeRoleSelection());

    // Boot Intercom with full configuration
    const intercomConfig: Record<string, any> = {
      app_id: 'm51ut11q',
    };

    if (!isEmpty(account)) {
      intercomConfig.user_id = account.id;
      intercomConfig.name = account.first_name
        ? `${account.first_name} ${account.last_name}`
        : account.email;
      intercomConfig.email = account.email;
      intercomConfig.created_at = account.created_at;
      intercomConfig.user_hash = account.intercom_hash;

      // Add site and settings attributes
      if (site) {
        intercomConfig.site_type = site.type;
        intercomConfig.site_id = site.id;
        intercomConfig.plan = site.billing_type;
      }
    }

    window.intercomSettings = intercomConfig;
    // Boot Intercom with the configuration
    Intercom(intercomConfig);

    // Show the Intercom messenger
    if (window.Intercom) {
      Intercom('update', intercomConfig);

      window.Intercom('show');
    } else {
      console.error('Intercom is not available. Please ensure it is properly initialized.');
    }
  };

  const handleAttendeeClick = () => {
    dispatch(closeRoleSelection());
    dispatch(openAttendeeTicketsModal());
    dispatch(fetchAttendeeTickets() as any);
  };

  const handleClose = () => {
    dispatch(closeRoleSelection());
  };

  return (
    <Dialog
      visible={isVisible}
      onHide={handleClose}
      header="How can we help you?"
      style={{ width: '400px' }}
      draggable={false}
      modal
    >
      <div className={styles.content}>
        <RedesignButton
          variation="primary"
          height={60}
          onClick={handleOrganizerClick}
          className={styles.roleButton}
        >
          <i className="pi pi-user" />
          <Text variation="body" color="white-100" bold>
            I'm an Organizer
          </Text>
        </RedesignButton>

        <RedesignButton
          variation="secondary"
          height={60}
          onClick={handleAttendeeClick}
          className={styles.roleButton}
        >
          <i className="pi pi-ticket" />
          <Text variation="body" color="brand-400" bold>
            I'm an Attendee
          </Text>
        </RedesignButton>
      </div>
    </Dialog>
  );
};
